import React from 'react';
import styles from './A_Button.module.css';

interface A_ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'tertiary';
  showIcon?: boolean;
  icon?: React.ReactNode;
  fontSize?: 'text-button' | 'text-p-4';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  width?: string | number;
}

export default function A_Button({
  children,
  variant = 'primary',
  showIcon = false,
  icon = null,
  fontSize = 'text-button',
  size = 'medium',
  disabled = false,
  onClick,
  type = 'button',
  className = '',
  width,
}: A_ButtonProps) {
  const buttonClasses = [
    styles.button,
    styles[variant],
    styles[size],
    fontSize,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      disabled={disabled}
      onClick={onClick ? e => onClick(e) : undefined}
      style={{ width }}
    >
      {showIcon && icon}
      {children}
    </button>
  );
}
